






















import Vue from 'vue';
export default Vue.extend({
  props: {
    quiz: {
      required: true,
      type: Object as () => StudentSolvedQuizResponse | SimpleQuizResponse,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
});
